(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-ochugen-template"]) return;
  try {
    
  //ページ読み込み完了後にinview実行（load後にbind）
  $(window).on('load', function() { //load後にbind
    $('.mv_bg div').on('inview', function() {
      $(this).addClass('isShow');
    });
  });

  //inviewを使わないでスクロールアニメーション
  $(window).on('scroll',function(){
      var scroll_top = $(window).scrollTop();
      //console.log(scroll_top);
      $('.scrollfadein').each(function(){
        //var offset_top = $(this).offset().top - $(this).height();
        var offset_top = $(this).offset().top / 2;
        if( scroll_top > offset_top){
            $(this).addClass('isShow'); 
        }else{
            $(this).removeClass('isShow');
        }
      });
  });

  //inviewとanimateクラスライブラリ(animate.min.css)を使ってを使ってスクロールアニメーション
  $(function() {
    $('.box1').on('inview', function(event, isInView) {
      if (isInView) {
      //表示領域に入った時
        $(this).addClass('fadeInDown');
      } else {
      //表示領域から出た時
        $(this).removeClass('fadeInDown');
        $(this).css('opacity',0); //非表示にしておく
      }
    });
    $('.box2').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('bounceIn');
      } else {
        $(this).removeClass('bounceIn');
      }
    });
    $('.box3').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('lightSpeedIn');
      } else {
        $(this).removeClass('lightSpeedIn');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-shochu-template"]) return;
  try {
    
  //ページ読み込み完了後にinview実行（load後にbind）
  $(window).on('load', function() { //load後にbind
    $('.mv_bg div').on('inview', function() {
      $(this).addClass('isShow');
    });
  });

  //inviewを使わないでスクロールアニメーション
  $(window).on('scroll',function(){
      var scroll_top = $(window).scrollTop();
      //console.log(scroll_top);
      $('.scrollfadein').each(function(){
        //var offset_top = $(this).offset().top - $(this).height();
        var offset_top = $(this).offset().top / 2;
        if( scroll_top > offset_top){
            $(this).addClass('isShow'); 
        }else{
            $(this).removeClass('isShow');
        }
      });
  });

  //inviewとanimateクラスライブラリ(animate.min.css)を使ってを使ってスクロールアニメーション
  $(function() {
    $('.box1').on('inview', function(event, isInView) {
      if (isInView) {
      //表示領域に入った時
        $(this).addClass('fadeInDown');
      } else {
      //表示領域から出た時
        $(this).removeClass('fadeInDown');
        $(this).css('opacity',0); //非表示にしておく
      }
    });
    $('.box2').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('bounceIn');
      } else {
        $(this).removeClass('bounceIn');
      }
    });
    $('.box3').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('lightSpeedIn');
      } else {
        $(this).removeClass('lightSpeedIn');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-zansho-template"]) return;
  try {
    
  //ページ読み込み完了後にinview実行（load後にbind）
  $(window).on('load', function() { //load後にbind
    $('.mv_bg div').on('inview', function() {
      $(this).addClass('isShow');
    });
  });

  //inviewを使わないでスクロールアニメーション
  $(window).on('scroll',function(){
      var scroll_top = $(window).scrollTop();
      //console.log(scroll_top);
      $('.scrollfadein').each(function(){
        //var offset_top = $(this).offset().top - $(this).height();
        var offset_top = $(this).offset().top / 2;
        if( scroll_top > offset_top){
            $(this).addClass('isShow'); 
        }else{
            $(this).removeClass('isShow');
        }
      });
  });

  //inviewとanimateクラスライブラリ(animate.min.css)を使ってを使ってスクロールアニメーション
  $(function() {
    $('.box1').on('inview', function(event, isInView) {
      if (isInView) {
      //表示領域に入った時
        $(this).addClass('fadeInDown');
      } else {
      //表示領域から出た時
        $(this).removeClass('fadeInDown');
        $(this).css('opacity',0); //非表示にしておく
      }
    });
    $('.box2').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('bounceIn');
      } else {
        $(this).removeClass('bounceIn');
      }
    });
    $('.box3').on('inview', function(event, isInView) {
      if (isInView) {
        $(this).addClass('lightSpeedIn');
      } else {
        $(this).removeClass('lightSpeedIn');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    var recommended_url = productRecommendationsSection.dataset.baseUrl;

    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;

    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    // Build request URL
    var requestUrl = recommended_url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;

    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
